import React, { useState, useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ReportIcon from '@mui/icons-material/Report';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import iconColetaExtra from '../../image/coletaExtraIconGreen.svg'
import iconColeta from '../../image/coletaIconGreen.svg'
import Paper from '@mui/material/Paper';
import { Badge, Box, CardActions, CardHeader, IconButton } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import EmailIcon from '@mui/icons-material/Email';
import api from '../../services/api';
import LoadingButton from '@mui/lab/LoadingButton';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { getToken } from '../../services/auth';
import HeaderBody from '../../components/HeaderBody';

function Notificacoes({showNotify, user}) {
    let initialized = false
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    useEffect(() => {
        setPage(1);
        const getStart = async (contrato) => {
            setLoading(true)
            setPage(0);
            let token = await getToken();
            api.get(`/clients/notifications`,{
                params: {
                    token,
                    page: 0,
                    limit: 10,
                }
            }).then(function (response) {
                let {data, status} = response.data;
                if(status === true){
                    if(data != null){
                        setList(data)
                    }else{
                        setList([])
                    }
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = false;
                setLoading(false)
            }).catch(function(error){
                console.log(error)
                setLoading(false)
                // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = false;
            });
        }
        if (!initialized) {
            initialized = true;
            getStart();
        }
        
    }, []);
    const [ page, setPage ] = useState(1);
    const [loadingBt, setLoadingBt] = useState(false);
    const loadMore = async (contrato) => {
        setLoadingBt(true)
        let token = await getToken();
        api.get(`/clients/notifications`,{
            params: {
                token,
                page,
                limit: 10,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(oldList => [...oldList, ...data]);
                }
            }
            setLoadingBt(false)
            setPage(page + 1);
        }).catch(function(error){
            console.log(error)
            setLoadingBt(false)
        });
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);
    const deleteNotificacao = async (id) =>{
        setList(list.filter(function(item){
            return item.id !== id
        }));
        api.post(`/clients/notifications/${id}`,{
            '_method': "delete"
        }).then(function (response) {
            console.log(response.data)
        }).catch(function(error){
            console.log(error)
        });
    }
    const renderFaturas = (element, idx) => {
        let {id, title, body, type, visualized, datetime} = element;
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12}>
                    <Card>
                        <CardHeader
                            avatar={
                                <>
                                    {type === 0 ? (
                                        <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                            <img
                                                src={iconColetaExtra}
                                                height="30"
                                                className="d-inline-block align-top"
                                                alt="Icone Coleta Extra"
                                                style={{float: "left", height: 35}}
                                            />
                                            </Avatar>
                                    ) : (
                                        type === 1 ? (
                                            <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                                <img
                                                    src={iconColeta}
                                                    height="30"
                                                    className="d-inline-block align-top"
                                                    alt="Icone Coleta"
                                                    style={{float: "left", height: 35}}
                                                />
                                            </Avatar>
                                        ) : (
                                            <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                                <ReportIcon color={"var(--main-white-color)"} size={30} />
                                            </Avatar>
                                        )
                                    )}
                                    {visualized === 0 && (
                                        <Badge variant="dot" overlap="circular" color="error" style={{marginRight: 10}} />
                                    )}
                                </>
                            }
                            title={title}
                            subheader={
                                <>
                                    {body}
                                    <br></br>
                                    {datetime}
                                </>
                            }
                            action={
                                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                                    <IconButton
                                        aria-label="Apagar Notificação"
                                        onClick={() => deleteNotificacao(id)}
                                        >
                                            <DeleteIcon />
                                    </IconButton>
                                </Box>
                            }
                        />
                    </Card>
                </Paper>
            </div>
        );
    }
    const [alerta, setAlerta] = useState(false);
    const Alert = React.forwardRef(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlerta(false);
    };
    return (
        <Card style={{margin: 20}}>
            <Loading open={loading} />
            <Card.Header>
                <HeaderBody title={"Notificações"} 
                setShow={showNotify}>
                    <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 35, height: 35, float: "left" }} >
                        <EmailIcon color={"var(--main-white-color)"} size={30} />
                    </Avatar>
                </HeaderBody>
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height}}>
                    {list.map((elemeto, index) => (
                        renderFaturas(elemeto, index)
                    ))}
                    {list.length > 0 && (
                        <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" >
                            <CardActions style={{justifyContent: 'space-around'}}>
                                <LoadingButton 
                                variant="secondary" 
                                loading={loadingBt} 
                                onClick={() => loadMore()}
                                >
                                    Mostrar mais...
                                </LoadingButton>
                            </CardActions>
                        </div>
                    )}
                </div>
            </Card.Body>
            <Snackbar open={alerta} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
                    Copiado para area de transferencia!
                </Alert>
            </Snackbar>
        </Card>
    );
}

export default Notificacoes;